import React from 'react';

export default function SearchResultItem({ teaser }) {
  return <div className="crtTeaser-wpr" dangerouslySetInnerHTML={{ __html: teaser }}></div>;
}
